import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Loading from "../../pages/components/loading";
import {
  ProtectedRoutesAuth,
  ProtectedRoutesWithoutAuth,
} from "./ProtectedRoutes";
import RegisterGooglePage from "../../pages/containers/register/google-register";
import TypeSelectGoogle from "../../pages/containers/register/selectType/selectType-google";
const HomePage = lazy(() => import("../../pages/containers/home"));
const NotesPage = lazy(() => import("../../pages/containers/project/notes"));
const NotFoundPage = lazy(() => import("../../pages/containers/not-found"));
const RegisterPage = lazy(() => import("../../pages/containers/register"));
const TypeSelect = lazy(
  () => import("../../pages/containers/register/selectType")
);
const ForgetPage = lazy(() => import("../../pages/containers/forget"));
const RecoverPage = lazy(() => import("../../pages/containers/recover"));
const VerifyEmailPage = lazy(
  () => import("../../pages/containers/verify-email")
);
const NewProjectPage = lazy(
  () => import("../../pages/containers/home/project/new")
);
const EditProjectPage = lazy(
  () => import("../../pages/containers/home/project/edit")
);
const SettingSelect = lazy(() => import("../../pages/containers/settings"));
const ProjectPage = lazy(() => import("../../pages/containers/project"));
const CreativeDocsPage = lazy(
  () => import("../../pages/containers/project/creative-docs")
);
const LocationsPage = lazy(
  () => import("../../pages/containers/project/locations")
);
const ContactsPage = lazy(
  () => import("../../pages/containers/project/contacts")
);
const CallSheetPage = lazy(
  () => import("../../pages/containers/project/call-sheet")
);
const CalendarPage = lazy(
  () => import("../../pages/containers/project/calendar")
);
const NewCallSheetPage = lazy(
  () => import("../../pages/containers/project/call-sheet/new")
);
const ConfirmCallsheetPage = lazy(
  () => import("../../pages/containers/confirming-callsheet")
)
const HelpAndSupportPage = lazy(
  () => import("../../pages/containers/project/help-support")
);
const PrivacyPolicy = lazy(
  () => import("../../pages/containers/project/privacy-policy")
);
const TermsAndConditions = lazy(
  () => import("../../pages/containers/project/terms-and-conditions")
);
const AppRouter = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      <Route
        path="/"
        element={<HomePage />}
      />
      <Route
        path="/confirm-callsheet/"
        element={<ConfirmCallsheetPage />}
      />
      <Route
        path="/privacy-policy"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/terms-and-conditions"
        element={<TermsAndConditions />}
      />
      <Route element={<ProtectedRoutesWithoutAuth />}>
        <Route
          path="/register"
          element={<RegisterPage />}
        />
        <Route
          path="/register/:type"
          element={<TypeSelect />}
        />
        <Route
          path="/register-google"
          element={<RegisterGooglePage />}
        />
        <Route
          path="/register-google/:type"
          element={<TypeSelectGoogle />}
        />
        <Route
          path="/forget"
          element={<ForgetPage />}
        />
        <Route
          path="/recover/:token"
          element={<RecoverPage />}
        />
        <Route
          path="/verify-email/:token"
          element={<VerifyEmailPage />}
        />
        <Route
          path="/verify-email"
          element={<VerifyEmailPage />}
        />
      </Route>
      <Route element={<ProtectedRoutesAuth />}>
        <Route
          path="/project/new"
          element={<NewProjectPage />}
        />
        <Route
          path="/project/edit/:projectId"
          element={<EditProjectPage />}
        />
        <Route
          path="/:type/settings"
          element={<SettingSelect />}
        />
        <Route
          path="/project/:projectId/*"
          element={<ProjectPage />}
        >
          <Route
            path="creative-docs"
            element={<CreativeDocsPage />}
          />
          <Route
            path="contacts"
            element={<ContactsPage />}
          />
          <Route
            path="locations"
            element={<LocationsPage />}
          />
          <Route
            path="call-sheet"
            element={<CallSheetPage />}
          />
          <Route
            path="call-sheet/confirm/"
            element={<CallSheetPage />}
          />
          <Route
            path="call-sheet/new"
            element={<NewCallSheetPage />}
          />
          <Route
            path="call-sheet/edit/:idCallsheet"
            element={<NewCallSheetPage />}
          />
          <Route
            path="calendar"
            element={<CalendarPage />}
          />
          <Route
            path="notes"
            element={<NotesPage />}
          />
          <Route
            path="projectDetails"
            element={<EditProjectPage />}
          />
        </Route>
        <Route
          path="/help"
          element={<HelpAndSupportPage />}
        />
      </Route>
      <Route
        path="*"
        element={<NotFoundPage />}
      />
    </Routes>
  </Suspense>
);

export default AppRouter;
